import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { AvForm, AvField } from "availity-reactstrap-validation";
import {
  Row, Col, Label, FormGroup 
} from "reactstrap";

const BillingForm = ({ t, setIsFirstStepValid, setPaymentPayload }) => {
  const clientData = useSelector((state) => state?.Profile?.clientData);
  
  const [formData, setFormData] = useState({
    email: clientData?.email || "",
    address: "",
    city: "",
    postalCode: "",
    country: clientData?.country || "",
  });

  const [isFormValid, setIsFormValid] = useState(false);

  // Check if all required fields are filled
  useEffect(() => {
    const { email, address, city, postalCode, country } = formData;
    const allFieldsFilled = email && address && city && postalCode && country;
    setIsFormValid(!!allFieldsFilled);
    setIsFirstStepValid(!!allFieldsFilled);

    // Always update payment payload with current billing information (not just when valid)
    setPaymentPayload(JSON.stringify({
      email,
      address,
      city,
      postalCode,
      country,
    }));
  }, [formData, setIsFirstStepValid, setPaymentPayload]);

  const handleFieldChange = (fieldName, value) => {
    setFormData((prev) => ({
      ...prev,
      [fieldName]: value,
    }));
  };

  return (
    <div className="mt-4">
      <h6 className="mb-3">{t("Billing Information")}</h6>
      <AvForm>
        <Row>
          <Col md={12}>
            <FormGroup>
              <Label htmlFor="billing-email">{t("Email Address")} *</Label>
              <AvField
                name="email"
                id="billing-email"
                type="email"
                placeholder={t("Enter email address")}
                value={formData.email}
                onChange={(e) => handleFieldChange("email", e.target.value)}
                validate={{
                  required: {
                    value: true,
                    errorMessage: t("Email is required"),
                  },
                  email: {
                    value: true,
                    errorMessage: t("Please enter a valid email"),
                  },
                }}
              />
            </FormGroup>
          </Col>
        </Row>

        <Row>
          <Col md={12}>
            <FormGroup>
              <Label htmlFor="billing-address">{t("Address")} *</Label>
              <AvField
                name="address"
                id="billing-address"
                type="text"
                placeholder={t("Enter street address")}
                value={formData.address}
                onChange={(e) => handleFieldChange("address", e.target.value)}
                validate={{
                  required: {
                    value: true,
                    errorMessage: t("Address is required"),
                  },
                  minLength: {
                    value: 5,
                    errorMessage: t("Address must be at least 5 characters"),
                  },
                }}
              />
            </FormGroup>
          </Col>
        </Row>

        <Row>
          <Col md={6}>
            <FormGroup>
              <Label htmlFor="billing-city">{t("City")} *</Label>
              <AvField
                name="city"
                id="billing-city"
                type="text"
                placeholder={t("Enter city")}
                value={formData.city}
                onChange={(e) => handleFieldChange("city", e.target.value)}
                validate={{
                  required: {
                    value: true,
                    errorMessage: t("City is required"),
                  },
                  minLength: {
                    value: 2,
                    errorMessage: t("City must be at least 2 characters"),
                  },
                }}
              />
            </FormGroup>
          </Col>

          <Col md={6}>
            <FormGroup>
              <Label htmlFor="billing-postal-code">{t("Postal Code")} *</Label>
              <AvField
                name="postalCode"
                id="billing-postal-code"
                type="text"
                placeholder={t("Enter postal code")}
                value={formData.postalCode}
                onChange={(e) => handleFieldChange("postalCode", e.target.value)}
                validate={{
                  required: {
                    value: true,
                    errorMessage: t("Postal code is required"),
                  },
                  minLength: {
                    value: 3,
                    errorMessage: t("Postal code must be at least 3 characters"),
                  },
                }}
              />
            </FormGroup>
          </Col>
        </Row>

        <Row>
          <Col md={12}>
            <FormGroup>
              <Label htmlFor="billing-country">{t("Country")} *</Label>
              <AvField
                name="country"
                id="billing-country"
                type="text"
                placeholder={t("Enter country")}
                value={formData.country}
                onChange={(e) => handleFieldChange("country", e.target.value)}
                validate={{
                  required: {
                    value: true,
                    errorMessage: t("Country is required"),
                  },
                  minLength: {
                    value: 2,
                    errorMessage: t("Country must be at least 2 characters"),
                  },
                }}
              />
            </FormGroup>
          </Col>
        </Row>
      </AvForm>
    </div>
  );
};

export default BillingForm;
